import React, { Component } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const statusLabels = {
    Rechazado: "Rechazado",
    Aceptado: "Aceptado",
    Invitado: "Pendiente por autorizar"
};

const statusClasses = {
    Rechazado: "status-pill status-pill--rejected",
    Aceptado: "status-pill status-pill--accepted",
    Invitado: "status-pill status-pill--pending"
};

class CompanyUpdateRequestsHistory extends Component {
    state = {
        requests: [],
        loading: true,
        error: null,
        cancelingId: null
    };

    componentDidMount() {  
        axios.get("/api/company-update-requests-history/" + this.props.id)
            .then(res => { 
                this.setState({
                    requests: res.data.data,
                    loading: false
                });
            })
            .catch(err => {
                let msg = "Error al cargar el historial";
                if (err.response && err.response.data && err.response.data.message) {
                    msg = err.response.data.message;
                }
                this.setState({ error: msg, loading: false });
            });
    }
    
    handleCancel = (id) => {
        Swal.fire({
            title: '¿Cancelar solicitud?',
            text: '¿Estás seguro de que deseas cancelar esta solicitud pendiente?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Cancelar Solicitud',
            cancelButtonText: 'Mantener',
            customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-secondary'
            },
            buttonsStyling: false
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ cancelingId: id });
                axios.delete(`/api/company-update-requests/${id}`)
                    .then(res => {
                        Swal.fire({
                            title: 'Solicitud cancelada',
                            text: 'La solicitud ha sido cancelada exitosamente',
                            icon: 'success',
                            showConfirmButton: false,
                            showCancelButton: false,
                            buttonsStyling: false,
                            customClass: {
                                popup: 'my-swal-height'
                            },
                            timer: 3000
                        });
                        this.setState({ cancelingId: null });
                        this.componentDidMount(); // Refrescar las solicitudes
                    })
                    .catch(err => {
                        let msg = "Error al cancelar la solicitud";
                        if (err.response && err.response.data && err.response.data.message) {
                            msg = err.response.data.message;
                        }
                        Swal.fire({
                            title: 'Error',
                            text: msg,
                            icon: 'error',
                            confirmButtonText: 'Aceptar',
                            customClass: {
                                confirmButton: 'btn btn-primary'
                            },
                            buttonsStyling: false
                        });
                        this.setState({ cancelingId: null });
                    });
            }
        });
    }

    render() {
        const { requests, loading, error } = this.state;
        return (
            <div className="mt-4 history-table-card">
                <div className="history-table-header mb-4">
                    <h3 className="card-label font-weight-bolder text-dark mb-1">
                        Historial de datos de la Empresa
                    </h3>
                    <span className="text-muted font-weight-bold font-size-lg mt-1 d-block">
                        Registro de cambios solicitados en la información de la empresa
                    </span>
                </div>
                {(requests && requests.length && this.props.showwarning) > 0 && (
                    <div className="alert alert-soft-warning mt-3 mb-3 d-flex align-items-center" role="alert">
                        <div>
                            <span className="flaticon2-warning mr-2 icon-3x"></span>
                        </div>
                        <div>   
                            Este historial muestra los cambios que solicitaste a tu invitado y su estatus. 
                        </div>
                    </div>
                )}
                <div className="table-responsive">
                    <table className="table history-table mb-0">
                        <thead>
                            <tr>
                                <th>Fecha de solicitud</th>
                                <th>Solicitado por</th>
                                <th className="history-col-status">Estatus</th>
                                <th>Motivo de rechazo</th>
                                <th> </th>
                            </tr>
                        </thead>
                        <tbody>
                        {loading && (
                            <tr><td colSpan="5">Cargando...</td></tr>
                        )}
                        {error && (
                            <tr><td colSpan="5" className="text-danger">{error}</td></tr>
                        )}
                        {!loading && !error && requests.length === 0 && (
                            <tr><td colSpan="5">No hay solicitudes.</td></tr>
                        )}
                        {!loading && !error && requests.map(req => (
                            <tr key={req.id}>
                                <td>{req.created_at?.split('T')[0] + ' ' + req.created_at?.split('T')[1]?.substring(0,8)}</td>
                                <td>{req.from_person_name || '-'}</td>
                                <td>
                                    <span className={statusClasses[req.status] || 'status-pill'}>
                                        {statusLabels[req.status] || req.status}
                                    </span>
                                </td>
                                <td>{req.rejected_message || ''}</td>
                                <td className="text-right">
                                    <div className="d-flex justify-content-end">
                                        { ( req.status === 'Invitado' && req.show_delete_button) && (
                                            <a
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    this.handleCancel(req.id);
                                                }}
                                                href="#"
                                                className="btn btn-xs btn-icon btn-light-secondary mr-4"
                                                disabled={this.state.cancelingId === req.id}
                                                style={{ pointerEvents: this.state.cancelingId === req.id ? 'none' : 'auto', opacity: this.state.cancelingId === req.id ? 0.6 : 1 }}
                                            >
                                                {this.state.cancelingId === req.id ? (
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                ) : (
                                                    <i className="flaticon-delete fw-normal text-primary"></i>
                                                )}
                                            </a>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default CompanyUpdateRequestsHistory;
